import type {Snapshot} from '@platform/contracts/x';
import {useCopy,useUi} from '@platform/ui/config';

// The shell owns the placement/style; ownership always comes from this draw's
// accepted stakes, never selected IDs, pending requests or a different draw.
export function useOwnedCardsMeta(state:Pick<Snapshot,'cards'>,context:'purchase'|'live'='purchase'){
 const t=useCopy(),ui=useUi(),owned=state.cards.filter(card=>card.ownMinor>0).length;
 return {
  text:t(!owned?'flow.noNextCardsPrompt':context==='live'?'flow.myNextCards':'flow.purchasedCards',{count:owned.toLocaleString(ui.controls.prizeDisplayLocale)}),
  dataUi:context==='live'?'next-owned-count':'purchase-owned-count',
  icon:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" aria-hidden="true"><rect x="3" y="7" width="14" height="14" rx="2"/><path d="M7 7V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-2"/></svg>
 };
}
